import type { Option } from '../Content'
import type { State } from './State'

const isPreCheck: Record<string, boolean> = {
  'built-in': true,
  preferred: true,
}

export const getInitialValue = (options: Option[]): State['value'] => {
  return options.reduce((value: State['value'], option) => {
    value[option.optionKey] = !!isPreCheck[option.level]
    return value
  }, {})
}
